const v = require('../../../../../version.json');

export const version = v.version;
